import * as Yup from 'yup';

export const initialValues = {
    startDate: null,
    endDate: null,
    type: { label: 'All', value: 'all' },
};

export const schema = Yup.object({
    startDate: Yup.date().nullable(),
    endDate: Yup.date().nullable(),
    type: Yup.object()
        .shape({
            value: Yup.string().required('Type value is required'),
            label: Yup.string().required('Type label is required'),
        })
        .nullable(),
});
